import * as LocalStorageManager from './StorageManager';
import { isDefined } from './Common';
import $ from 'jquery';

const HttpService = {
    call(arquivo, funcao, parametros, callback, async = true, timeout = 500, dataType = 'json', method = 'POST', url = 'https://sc.mysaas.com.br/portal_pedidos/services/executar.php') {
        const idtCliente = isDefined(LocalStorageManager.getEmpresa()) ? LocalStorageManager.getEmpresa().idtCliente : null;
        const origem = isDefined(LocalStorageManager.getOrigem()) ? LocalStorageManager.getOrigem().idt : null;

        setTimeout(() => { 
            $.ajax({
                url,
                dataType,
                method,
                async,
                data: JSON.stringify({
                    config: {
                        arquivo,
                        funcao,
                        idtCliente,
                        origem
                    },
                    parametros
                }),
                crossDomain: true,
                success: callback,
                error: (jqXHR, textStatus, errorThrown) => {
                    console.log(jqXHR)
                    callback(undefined)
                }
            })
        }, timeout)
    }
}

export default HttpService;


// WEBPACK FOOTER //
// ./src/util/HttpService.js